import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons';
import {handleLinkClick} from "../../../../../Utils/misc/openLink.ts";
import {useAppStore} from "../../../../../GlobalStore/GlobalStore.ts";

interface DeleteAccountButtonProps {}

const DeleteAccountButton: React.FC<DeleteAccountButtonProps> = ({ }) => {
    const environmentObj = useAppStore((state: any) => state.environmentObj);
    const { environment, vscode } = environmentObj;
    
    return (
        <div className="mt-6 text-center">
            <hr className="border-gray-300 dark:border-gray-600 mb-6"/>
            <a
                href="https://www.onuro.ai/manage-account"
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center px-4 py-2 bg-red-600 dark:bg-red-700 text-white rounded-md hover:bg-red-500 dark:hover:bg-red-600 transition-colors duration-200"
                onClick={(e) => handleLinkClick(e, environment, vscode, "https://www.onuro.ai/manage-account")}
            >
                Delete Account
                <FontAwesomeIcon icon={faExternalLinkAlt} className="ml-2.5 h-3.5 w-3.5"/>
            </a>
        </div>
    )
};

export default DeleteAccountButton;